const Landing = Object.freeze({
  Classic: 'Classic',
  BaseLine: 'BaseLine',
  Warwick: 'Warwick',
  WarwickV1: 'WarwickV1',
});

const Theme = Object.freeze({
  Maroon: 'Maroon',
  CharcoalBlue: 'CharcoalBlue',
});

export { Landing, Theme };
